import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { linksAPI } from '../api/axios';

const PublicLinksContext = createContext({
  links: {},
  loading: true,
  refresh: async () => {},
});

export const PublicLinksProvider = ({ children }) => {
  const [links, setLinks] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchLinks = useCallback(async () => {
    setLoading(true);
    try {
      const publicResponse = await linksAPI.getPublic();
      const publicLinks = publicResponse.data.links || {};
      setLinks(publicLinks);
      return publicLinks;
    } catch (error) {
      console.error('Failed to load public links', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLinks();
  }, [fetchLinks]);

  const value = useMemo(
    () => ({ links, loading, refresh: fetchLinks }),
    [links, loading, fetchLinks]
  );

  return (
    <PublicLinksContext.Provider value={value}>
      {children}
    </PublicLinksContext.Provider>
  );
};

export const usePublicLinks = () => useContext(PublicLinksContext);
